<template>
  <v-dialog v-model="show" persistent max-width="640">
    <v-card width="800" style="padding: 24px;">
      <div
        class="d-flex justify-space-between">
        <span
          class="primary--text font-weight-bold"
          style="font-weight: 18px;">
          Exportar Relatório
        </span>

        <v-icon @click="hideModal()">
          mdi-close
        </v-icon>
      </div>

      <div
        style="padding-top: 24px;">
        <Textfield
          value="Relatório de Maioridade"
          regular
          disabled
          hide-details
        />
      </div>

      <div
        class="d-flex justify-end gap-h-20"
        style="padding-top: 24px;">
        <v-btn
          outlined
          color="primary"
          :style="btnExport.style"
          @click="hideModal()">
          Cancelar
        </v-btn>

        <v-btn
          class="white--text"
          color="primary"
          :style="btnExport.style"
          @click="requestExport()">
          Enviar
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import MajorityMixin from '@/shared/mixins/majority/majorityMixin';
import { mapActions, mapMutations } from 'vuex';
import Textfield from './Textfield.vue';

export default {
  name: "ExportReportModal",

  components: {
    Textfield,
  },

  mixins: [
    MajorityMixin,
  ],

  props: {
    show: {
      type: Boolean,
      default: false,
    }
  },

  methods: {
    ...mapActions({
      exportReport: 'majority/exportReport',
    }),

    ...mapMutations({
      showExportConfirmModal: 'majority/showExportConfirmModal',
      showExportRequestModal: 'majority/showExportRequestModal',
    }),

    showConfirmModal() {
      this.hideModal();
      this.showExportConfirmModal(true);
    },

    requestExport() {
      this.exportReport()
        .then((result) => this.showConfirmModal())
        .catch((error) => {
          this.showMessage('error', 'Ocorreu um erro durante solicitação de exportação de relatório!')
        });
    },

    showMessage(statusMessage, message) {
      const majoritySnackbar = this.majorityViewReference()?.$refs.MajoritySnackbar || false;

      majoritySnackbar.open(
        statusMessage,
        message
      );
    },

    hideModal() {
      this.showExportRequestModal(false);
    }
  }
}
</script>